import axios, { GET } from './axios';

/**
 * Fetches the current shopping cart.
 * @returns {Promise<object>} The cart response data.
 */
export function getCart() {
  const timestamp = new Date().getTime()
  return axios({
    method: GET,
    url: `insightweb/transaction/getcart?_=${timestamp}`,
  }).catch((error) => {
    console.warn('Error getting cart: ' + error)
    throw error
  })
}

export default getCart;

